

import type { SpectroInfo } from "../geoJSUtils";
import type { LayerStyle } from "./types";
import geo from "geojs";



export default abstract class BaseTextLayer<D> {
  textData: D[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  textLayer: any;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  geoViewerRef: any;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  event: (name: string, data: any) => void;

  spectroInfo: SpectroInfo;

  textStyle: LayerStyle<D>;

  scaledWidth: number;
  scaledHeight: number;

  color = "white";



  textScaled: number | undefined;

  zoomLevel: number;

  xScale: number;

  compressedView: boolean;

  constructor(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    geoViewerRef: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    event: (name: string, data: any) => void,
    spectroInfo: SpectroInfo
  ) {
    this.geoViewerRef = geoViewerRef;
    this.spectroInfo = spectroInfo;
    this.textData = [];
    this.scaledWidth = 0;
    this.scaledHeight = 0;
    this.event = event;
    this.xScale = 0;
    this.compressedView = false;
    //Only initialize once, prevents recreating Layer each edit
    this.textStyle = this.createTextStyle();
    this.geoViewerRef.geoOn(geo.event.zoom, (event: {zoomLevel: number}) => this.onZoom(event));
    this.zoomLevel = this.geoViewerRef.camera().zoomLevel;

  }

  setScaledDimensions(newWidth: number, newHeight: number) {
    this.scaledWidth = newWidth;
    this.scaledHeight = newHeight;
    if (this.spectroInfo.compressedWidth) {
      this.xScale = newWidth / this.spectroInfo.compressedWidth;
      this.compressedView = true;
    } else {
      this.xScale = newWidth / this.spectroInfo.width;
      this.compressedView = false;
    }
  }

  onZoom(event: {zoomLevel: number}) {
    this.zoomLevel = event.zoomLevel;
    this.textScaled = undefined;
    if ((this.zoomLevel || 0) < -1.5 ) {
      this.textScaled = -1.5;
    } else if ((this.zoomLevel || 0) > 0) {
      this.textScaled = Math.sqrt(this.zoomLevel || 1);
    } else {
      this.textScaled = this.zoomLevel;
    }
    this.redraw();
  }

  setTextColor(newColor: string) {
    this.color = newColor;
    this.textStyle = this.createTextStyle();
    this.redraw();
  }


  destroy() {
    if (this.textLayer) {
      this.geoViewerRef.deleteLayer(this.textLayer);
    }
  }



  redraw() {
    // add some styles
    this.textLayer.data(this.textData).style(this.createTextStyle()).draw();
  }

  disable() {
    this.textLayer.data([]).draw();
  }

  getFontSize(fontA: number, fontB: number, xScale: number) {
  if (xScale >= 2.5) {
    return fontA; // clamp high
  } else if (xScale <= 1.0) {
    return fontB; // clamp low
  } else {
    const t = (xScale - 1.0) / (2.5 - 1.0); // normalized progress
    return fontB + t * (fontA - fontB);     // linear interpolation
  }
}


  createTextStyle(): LayerStyle<D> {
    return {
      ...{
        strokeColor: () => this.color,
        strokeWidth: 2.0,
        antialiasing: 0,
        stroke: true,
        uniformPolygon: true,
        fill: false,
        fontSize: () => this.xScale < 2.5 ? '12px' : '16px'
      },
      color: () => {
        return this.color;
      },
      textScaled: this.textScaled,
      textBaseline: 'middle',
    };
  }

}
